export default "__VITE_ASSET__782eec0d__"